/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React, { Component } from 'react';
// material
import Page from 'material/structure/page/page';
import Content from 'material/structure/content/content';
// pages
import AnalyticsOverview from 'pages/dashboard/analytics/overview/overview_container';
// styles
import injectSheet from 'react-jss';
import styles from 'pages/dashboard/home/home_styles';
import PervasiveMessage from 'material/message/pervasivemessage/pervasivemessage_container';




/* ========== ~~~~~~~~~~ PAGE : HOME : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
class HomePage extends Component {
    render() {
        return(
            <Page name={`home`} klass={this.props.classes.home}>
                <Content>
                    {/*<Notification variant={`primary`} size={`full`} icon={`bullhorn`} text={<span><strong>New Update:</strong> We’ve built an improved report builder. <Link type={`internal`} text={`Try it now!`} color={`white`} action={`dashboard/reports`} underline /></span>} />*/}
                    <PervasiveMessage/>
                    <AnalyticsOverview />
                </Content>
            </Page>
        );
    }
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// will be utilized in parent component after being infused with app state & actions
export default injectSheet(styles)(HomePage);
